import { NSARouterMakerResult, NSAHomePage, NSAPlanStatus } from "namirasoft-account-react";
import { PaymentBase } from "namirasoft-payment";
import { NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { SupportLayout } from "../SupportLayout";
import { SupportProps } from "../SupportProps";
import SupportChannels from "../components/SupportChannels";

export interface HomePageProps extends NSARouterMakerResult, SupportProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <SupportLayout {...props}
            action={{ menus: {} }}
        >
            <NSAHomePage
                {...props}
                getChildren={{
                    getChildrenBetween: () => (
                        <>
                            <div style={{ width: "100%", maxWidth: "24rem" }}>
                                <NSAPlanStatus {...props} sales_item_id={PaymentBase.NAMIRASOFT_SUPPORT.sales_items.MEMBERSHIP.id} />
                            </div>
                            <NSSpace size={NSSpaceSizeType.SMALL} />
                            <SupportChannels
                                ticket={true}
                                chat={true}
                                email={true}
                                meeting={true}
                            />
                        </>
                    )
                }}
            />

        </SupportLayout>
    );
}